export default "__VITE_ASSET__10932b5a__"